<template>
  <div class="button-container">
    <button @click="$emit('done')" class="btn large"><span>To Decisions</span> <i class="material-icons">chat_bubble_outline</i></button>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "injects-panel",
  mixins: [scenarioMixin],
  // components: { TimelineContainer },
  methods: {
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    openModal (playlist) {
      this.$store.dispatch('modalModule/setActive', this.getInjectData(playlist[0]) )
      this.$store.dispatch('modalModule/setMediaPlaylist', playlist )
    }
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  position: sticky;
  bottom: 0;
  top: 200px;
}
</style>